var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { markRaw, createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  viewBox: "0 0 24 24",
  width: "1.2em",
  height: "1.2em"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, [
      createElementVNode("path", { d: "M12 10a2 2 0 1 0 4 0a2 2 0 1 0-4 0" }),
      createElementVNode("path", { d: "M21 12a9 9 0 1 1-18 0a9 9 0 0 1 18 0" }),
      createElementVNode("path", { d: "m12.5 11.5l-4 4L10 17m2-2l-1.5-1.5" })
    ], -1)
  ]));
}
__name(render, "render");
const circleKey = markRaw({ name: "tabler-circle-key", render });
export {
  circleKey as default
};
//# sourceMappingURL=circle-key.js.map
